const setupVisibilityAnimation = timeline => {
    const milestoneContents = timeline.querySelectorAll('.milestone__content');
    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('milestone__content--visible');
                    entry.target.classList.remove('milestone__content--hidden');
                    observer.unobserve(timeline);
                }
            });
        },
        {
            root: timeline,
            rootMargin: '0px',
            threshold: [0.5],
        },
    );

    milestoneContents.forEach(milestone => {
        milestone.classList.add('milestone__content--hidden');
        observer.observe(milestone);
    });
};

const setupNavigation = timeline => {
    const nav = timeline.parentElement?.querySelector('.timeline__navigation') ?? null;
    if (!nav) return;

    const prevButton = nav.querySelector('[data-action="prev"]');
    const nextButton = nav.querySelector('[data-action="next"]');
    const jumpToCurrentButton = nav.querySelector('[data-action="current"]');
    const currentItem = timeline.querySelector('[data-current]');
    const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';

    const itemWidth = () =>
        timeline.querySelector('.timeline__item')?.getBoundingClientRect().width ?? 0;

    const scrollToCurrent = () => {
        if (!currentItem) return;
        timeline.style.scrollSnapType = 'none';
        timeline.addEventListener('scrollend', () => (timeline.style.scrollSnapType = ''), {
            once: true,
        });
        currentItem.scrollIntoView({
            behavior: scrollBehavior,
            inline: 'start',
            block: 'nearest',
        });
    };

    const updateButtons = () => {
        const { scrollLeft, scrollWidth, clientWidth } = timeline;
        if (prevButton) prevButton.disabled = scrollLeft <= 0;
        if (nextButton) nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    };

    prevButton?.addEventListener('click', () => {
        timeline.scrollBy({ left: -itemWidth(), behavior: scrollBehavior });
    });

    nextButton?.addEventListener('click', () => {
        timeline.scrollBy({ left: itemWidth(), behavior: scrollBehavior });
    });

    jumpToCurrentButton?.addEventListener('click', scrollToCurrent);

    timeline.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
};

document.querySelectorAll('.timeline').forEach(timeline => {
    setupVisibilityAnimation(timeline);
    setupNavigation(timeline);
});
